const $ = jQuery.noConflict();

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

'use strict';
const scrollGsap = {

	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domScrollImg: $('.js-scroll-img'),
	$domScrollBox: $('.js-scroll-box'),
	$domScrollItem: $('.js-scroll-item'),

	/** @description Initialize */
	init: function() {
		scrollGsap.sectionHeights();
		scrollGsap.appendImages();
		$(window).resize(function() {
			scrollGsap.sectionHeights();
		});
		setTimeout(() => {
			scrollGsap.initScrollGsap();
		}, 50);
	},

	initScrollGsap: function() {
		if (scrollGsap.$domScrollItem.length > 0 && $(window).width() > 1199) {
			const sections = gsap.utils.toArray('.js-scroll-item');
			let position = 'top top';
			let positionEnd = sections.length * 1000 + 1000;
			let imagePosition = '-23%';
			let imagePositionEnd = sections.length * 1000;

			if ($(window).width() < 1300) {
				position = 'center center';
				imagePosition = 'center center';
			}

			if (sections.length > 3) {
				positionEnd = sections.length * 1000 + 900;
				imagePositionEnd = sections.length * 1000 + 150;
			}

			// eslint-disable-next-line
			const scrollTween = gsap.to(sections, {
				yPercent: -100 * (sections.length - 1),
				ease: 'none',
				scrollTrigger: {
					trigger: '.js-scroll-section',
					pin: true,
					scrub: 0.5,
					start: position,
					end: `+=${positionEnd}`,
				}
			});

			gsap.timeline(
				{
					scrollTrigger: {
						trigger: '.js-scroll-section',
						scrub: 0.5,
						start: imagePosition,
						end: `+=${imagePositionEnd}`,
					},
					defaults: {
						duration: 1,
						ease: 'none'
					}
				})
				.to('.scroll-block__img-wrap', {
					opacity: 1,
					duration: 0.1,
					stagger: {
						each: 1.5,
						from: 1,
					}
				}, 1);
		}
	},

	sectionHeights: function() {
		if ($(window).width() > 1299) {
			const height = scrollGsap.$domScrollImg.height();
			scrollGsap.$domScrollBox.css('height', height + 'px');
			scrollGsap.$domScrollItem.css('min-height', height - 100 + 'px');
		}
		if ($(window).width() > 1199 && $(window).width() < 1300) {
			const height = scrollGsap.$domScrollImg.height();
			scrollGsap.$domScrollBox.css('height', height + 'px');
			scrollGsap.$domScrollItem.css('min-height', height + 'px');
		}
	},

	appendImages: function() {
		if ($(window).width() < 1200) {
			scrollGsap.$domScrollImg.each(function() {
				const imgNumber = $(this).data('img');
				$(this).appendTo(`.js-scroll-item[data-img="${imgNumber}"]`);
			});
		}
	},

};

export default scrollGsap;
